import React from 'react';
import { BatteryFullIcon, SignalIcon, WifiIcon } from 'lucide-react';
type StatusBarProps = {
  tone?: 'dark' | 'light';
};
export function StatusBar({
  tone = 'dark'
}: StatusBarProps) {
  return <div className={`relative z-20 flex items-center justify-between px-6 pt-2.5 text-[10px] font-semibold ${tone === 'light' ? 'text-white' : 'text-ink'}`} data-id="element-168" data-mp="qfd1nztbz8fr">
      <span data-id="element-169" data-mp="ghowefy3mijc">9:41</span>
      <span className="flex items-center gap-1" data-id="element-170" data-mp="gj08d31p6wlj">
        <SignalIcon className="h-2.5 w-2.5" data-id="element-171" data-mp="gjt8hl65inup" />
        <WifiIcon className="h-2.5 w-2.5" data-id="element-172" data-mp="bq74ehe1zsai" />
        <BatteryFullIcon className="h-3 w-3" data-id="element-173" data-mp="bp5i1grl7jdh" />
      </span>
    </div>;
}